var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-avatar',[_c('img',{attrs:{"src":"http://colel.herokuapp.com/image/logo.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }